import { render, staticRenderFns } from "./SchoolGrade.vue?vue&type=template&id=d3df6d3a&"
import script from "./SchoolGrade.vue?vue&type=script&lang=js&"
export * from "./SchoolGrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports